import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';
import { useInView } from 'lib/useInView';
import { Handshake } from 'lucide-react';

const PartnerSection = ({ t }) => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-gray-900/50 to-background" ref={ref}>
      <div className={`max-w-6xl mx-auto px-6 md:px-12 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="bg-gradient-to-br from-gray-900/90 to-gray-900/50 rounded-3xl p-8 md:p-16 border border-gray-800 relative overflow-hidden backdrop-blur-sm shadow-2xl">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-primary/10 to-primary/5 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tl from-primary/5 to-transparent rounded-full blur-3xl" />

          <div className="relative z-10 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary/20 to-primary/5 rounded-2xl mb-6 border border-primary/10">
              <Handshake className="w-8 h-8 text-primary" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              {t('partner.title')}
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
              {t('partner.subtitle')}
            </p>
            <a
              href="mailto:cs@bgms.live?subject=[BGMs] Partnership Inquiry"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary/80 text-black font-bold py-4 px-8 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg shadow-primary/25 hover:shadow-primary/40"
            >
              {t('partner.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

PartnerSection.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('index')(PartnerSection);
